import { navigate } from '@reach/router'
import React, { useEffect, useState, } from 'react'
import { TemplateProps } from '../../../journeys/journey/Interfaces'
import { Typography } from "@material-ui/core";
import { Button as AmsButton, CustomIcon, Cards } from 'ams-ui-reactkit';
import { Dialog, TitleBlock } from '../../../atoms';
import Button from '@material-ui/core/Button';
import './ValuationDetails.scss'
import { AddSignatureBlock, ItemBlock } from '../../../organisms';
import { callUpdateValuation } from '../../../graphql/getValuation.query';
import { StoreContext } from '../../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import DynamicHtml from '../../../molecules/DynamicHtml';
import { getSignatureByIndex } from "./../../../common/GlobalUtils";
import { getCustomerId } from '../../../utils/Utils';

export interface SelectItemProps {
    popUpTitle: any
    popUpContent: any
}

const Valuation: React.FC<TemplateProps> = (props: any) => {
    const valuationInfo: any = useContextSelector(StoreContext, store => store?.appState?.valuationInfo);
    const signatures: any = useContextSelector(StoreContext, store => store?.appState?.signatures);
    const signByInd = getSignatureByIndex(signatures?.list, 1)
    const sign = signByInd?.getUrl || "";
    const { templateProps } = props;
    const [open, SetPopup] = useState(false)
    const [isUpdate, SetisUpdate] = useState(false)
    const [enableButton, setEnableButton] = useState(false);

    const [enableCheckbox, SetEnableCheckBox] = useState(false)
    const [buttonEnabled, setButtonEnabled] = useState(templateProps && templateProps.buttonEnabled ? templateProps.buttonEnabled : 0);
    const [objectData, setObjectData] = useState<SelectItemProps>();
    const [loader, setLoader] = useState(false)
    const [valuationDeclaration, setValuationDeclarationData] = useState<any>()

    useEffect(() => {
        (enableCheckbox) ? setEnableButton(true) : setEnableButton(false);
    }, [enableCheckbox])

    useEffect(() => {
        getvaluationOptionData()
    }, [])

    const getvaluationOptionData = () => {
        let selectedOption = templateProps?.optionData?.filter((data: any) => data.optionId === valuationInfo?.selectedValuationOptions?.optionId.toString());
        if (valuationInfo?.selectedValuationOptions?.optionId === 1) {
            let selectedOptionData: any = valuationInfo?.selectedOptionData
            let updateDataItems: any = { ...selectedOption[0].section[0], "dataItems": selectedOptionData }
            let valuationDeclarationData = { ...selectedOption[0], "section": [updateDataItems] }
            setValuationDeclarationData(valuationDeclarationData)

        } else {
            setValuationDeclarationData(selectedOption[0])

        }
    }
    const handleClose = () => {
        SetPopup(false)
    }
    const handleSignClick = (e: any) => {
        SetEnableCheckBox(!enableCheckbox)
        setButtonEnabled(!buttonEnabled)
    }
    const openPopUP = (item: any) => {
        SetPopup(true)
        SetisUpdate(false)
        setObjectData({
            "popUpTitle": item.title,
            "popUpContent": item.content
        })


    }
    const PopupFooter = () => {
        return <>

            <Button onClick={handleClose} color="primary" variant="outlined" className='b-transparent'>
                {"CLOSE"}
            </Button>
            {isUpdate &&
                <Button onClick={handleClose} color="primary" variant="contained" >
                    {"UPDATE"}
                </Button>

            }
        </>
    }

    const PopupBody = () => {
        return <div className="full-block">
            <Typography variant="body2" variantMapping={{ body2: "div" }} align='left' className="fw-400 color-grey">
                <DynamicHtml content={objectData?.popUpContent} />
            </Typography>
        </div>
    }

    const handleBtn = async () => {
        setLoader(true);

        let shipmentValue;

        /**
         * Dont pass declaredValue for standardValuation option which is optionId 0
         */
        if (valuationInfo?.selectedValuationOptions?.optionId === 1) {
            shipmentValue = valuationInfo?.shipmentValue || valuationInfo?.defaultShipmentValue;
        }

        const params = {
            "customerId": getCustomerId(),
            "optionId": valuationInfo?.selectedValuationOptions?.optionId,
            "deductableId": valuationInfo?.selectedValuationOptions?.deductibleId,
            ...(shipmentValue && { "declaredValue": shipmentValue })
        }
        let respData = await callUpdateValuation(params)
        setLoader(false)
        if (respData) {
            navigate(templateProps?.nextScreen || '/')
        }
    }

    return (
        <div className="baseContainerBlock valuationPage">
            <TitleBlock title={templateProps?.title} />
            <Typography variant="caption" color='textPrimary' noWrap={false} align='center' className='color-red full-block pb-16 fw-500'>
                {templateProps?.subtitle}
            </Typography>
            <Cards variant="default">
                <div className="pl-8 pr-8">
                    <div className="singleCardItemTitle mb-8">
                        <Typography variant='h5' color='textPrimary' className="mb-0 fw-400 color-grey" noWrap={false} align='left'>
                            {valuationDeclaration?.header}
                        </Typography>
                        <span onClick={valuationDeclaration?.helper ? () => { openPopUP(valuationDeclaration?.helper) } : () => { return null }}><CustomIcon iconName={"InfoOutlined"} /></span>
                    </div>
                    <div className="mt-8 mb-8 full-block color-grey valuationDetailsCls">
                        <ItemBlock  {...valuationDeclaration} variant={true} />
                    </div>

                    {templateProps.signCard && <div className="border-t-l color-grey full-block pt-8">
                        <div className="mb-16">
                            <Typography variant='subtitle2' color='textPrimary' align="left" className="fw-500 pt-8 pb-8 color-grey">{templateProps.signCard.title}</Typography>
                            <Typography variant='caption' color='textPrimary' align="left" className='color-grey'>  <DynamicHtml content={valuationDeclaration?.valuationTerms} /></Typography>
                        </div>
                        <AddSignatureBlock signature={sign} enable={enableButton} onClick={handleSignClick} />
                    </div>}
                    <div className="staticFixedButton">
                        <AmsButton
                            text={templateProps?.button}
                            onClick={() => { handleBtn() }}
                            color={"primary"}
                            variant={"contained"}
                            size={"large"}
                            loading={loader}
                            disabled={!enableButton}
                        />
                    </div>
                </div>
                <Dialog title={objectData?.popUpTitle} open={open} handleClose={handleClose} footer={PopupFooter()}>
                    {PopupBody()}
                </Dialog>
            </Cards>
        </div>
    )
}

export default Valuation
